import { ALL_LAYOUT_RESIZE_HANDLES } from "../layoutSettings/layoutSettings.types";
import type { WorkspaceDocument } from "./workspace.document";

/** Placeholder ids — remapped on every instantiate; never used as live ids. */
export const DEFAULT_LAYOUT_TEMPLATE: WorkspaceDocument = {
  schemaVersion: 3,
  revision: 0,
  engine: "rgl",
  workspaces: [
    {
      id: "2bb8d934-55ff-44b1-8b07-6e0c78d25c14",
      name: "Home",
      workspace: {
        engine: "rgl",
        placements: [
          {
            widgetId: "29f4d465-c6da-4cec-84fb-4bf7eb3345d1",
            x: 0,
            y: 12,
            w: 16,
            h: 11,
            minW: 3,
            minH: 6,
          },
          {
            widgetId: "8a4ff0ab-2aea-43ba-9866-a6a97208385f",
            x: 0,
            y: 0,
            w: 16,
            h: 12,
            minW: 4,
            minH: 6,
          },
          {
            widgetId: "9e9ddaad-c558-482e-8a19-f899c273dcf9",
            x: 16,
            y: 12,
            w: 8,
            h: 11,
            minW: 2,
            minH: 6,
          },
          {
            widgetId: "c8a6b1cd-663c-4ac6-b3ff-7f1163896005",
            x: 16,
            y: 0,
            w: 8,
            h: 12,
            minW: 3,
            minH: 8,
          },
        ],
        widgets: [
          {
            id: "29f4d465-c6da-4cec-84fb-4bf7eb3345d1",
            kind: "positions",
          },
          {
            id: "8a4ff0ab-2aea-43ba-9866-a6a97208385f",
            kind: "portfolioHistory",
          },
          {
            id: "9e9ddaad-c558-482e-8a19-f899c273dcf9",
            kind: "watchlist",
          },
          {
            id: "c8a6b1cd-663c-4ac6-b3ff-7f1163896005",
            kind: "orderTicket",
          },
        ],
        widgetSettings: {
          "8a4ff0ab-2aea-43ba-9866-a6a97208385f": {
            kind: "portfolioHistory",
            comparisons: [],
          },
        },
      },
      settings: {
        cols: 24,
        rowHeight: 30,
        marginX: 8,
        marginY: 8,
        containerPaddingMode: "margin",
        containerPaddingX: 8,
        containerPaddingY: 8,
        maxRows: {
          limited: false,
          value: 100,
        },
        autoSize: true,
        compactor: "vertical",
        bounded: false,
        dragThreshold: 3,
        resizeHandles: [...ALL_LAYOUT_RESIZE_HANDLES],
        positionStrategy: "transform",
        positionScale: 1,
        gridBounds: true,
        containerBounds: false,
        boundedX: false,
        boundedY: false,
        minMaxSize: true,
        globalMin: {
          enabled: false,
          w: 1,
          h: 1,
        },
        globalMax: {
          enabled: false,
          w: 24,
          h: 40,
        },
        snap: {
          enabled: false,
          x: 1,
          y: 1,
        },
        aspect: {
          enabled: false,
          ratio: 1.7777777777777777,
        },
        externalDrop: {
          enabled: false,
          w: 1,
          h: 1,
        },
      },
    },
    {
      id: "12e9ef5e-e323-4529-a94c-b5069bad619b",
      name: "Positions",
      workspace: {
        engine: "rgl",
        placements: [
          {
            widgetId: "a7c6b41b-8e01-4edd-a92a-58feb3129ac8",
            x: 0,
            y: 0,
            w: 24,
            h: 18,
            minW: 3,
            minH: 6,
          },
        ],
        widgets: [
          {
            id: "a7c6b41b-8e01-4edd-a92a-58feb3129ac8",
            kind: "positions",
          },
        ],
        widgetSettings: {},
      },
      settings: {
        cols: 24,
        rowHeight: 30,
        marginX: 8,
        marginY: 8,
        containerPaddingMode: "margin",
        containerPaddingX: 8,
        containerPaddingY: 8,
        maxRows: {
          limited: false,
          value: 100,
        },
        autoSize: true,
        compactor: "vertical",
        bounded: false,
        dragThreshold: 3,
        resizeHandles: [...ALL_LAYOUT_RESIZE_HANDLES],
        positionStrategy: "transform",
        positionScale: 1,
        gridBounds: true,
        containerBounds: false,
        boundedX: false,
        boundedY: false,
        minMaxSize: true,
        globalMin: {
          enabled: false,
          w: 1,
          h: 1,
        },
        globalMax: {
          enabled: false,
          w: 24,
          h: 40,
        },
        snap: {
          enabled: false,
          x: 1,
          y: 1,
        },
        aspect: {
          enabled: false,
          ratio: 1.7777777777777777,
        },
        externalDrop: {
          enabled: false,
          w: 1,
          h: 1,
        },
      },
    },
    {
      id: "b8afc0fc-8368-4392-9317-dce2204f7b37",
      name: "Orders",
      workspace: {
        engine: "rgl",
        placements: [
          {
            widgetId: "e6c4db88-37f5-4d7e-b6b6-158d19f2e58e",
            x: 0,
            y: 0,
            w: 24,
            h: 18,
            minW: 3,
            minH: 6,
          },
        ],
        widgets: [
          {
            id: "e6c4db88-37f5-4d7e-b6b6-158d19f2e58e",
            kind: "orders",
          },
        ],
        widgetSettings: {},
      },
      settings: {
        cols: 24,
        rowHeight: 30,
        marginX: 8,
        marginY: 8,
        containerPaddingMode: "margin",
        containerPaddingX: 8,
        containerPaddingY: 8,
        maxRows: {
          limited: false,
          value: 100,
        },
        autoSize: true,
        compactor: "vertical",
        bounded: false,
        dragThreshold: 3,
        resizeHandles: [...ALL_LAYOUT_RESIZE_HANDLES],
        positionStrategy: "transform",
        positionScale: 1,
        gridBounds: true,
        containerBounds: false,
        boundedX: false,
        boundedY: false,
        minMaxSize: true,
        globalMin: {
          enabled: false,
          w: 1,
          h: 1,
        },
        globalMax: {
          enabled: false,
          w: 24,
          h: 40,
        },
        snap: {
          enabled: false,
          x: 1,
          y: 1,
        },
        aspect: {
          enabled: false,
          ratio: 1.7777777777777777,
        },
        externalDrop: {
          enabled: false,
          w: 1,
          h: 1,
        },
      },
    },
  ],
};
